import {
  Fragment,
  useEffect,
  useState,
  useRef,
  useContext,
  createRef,
} from "react";
import styleData from "../../../pages/UnifiedTaxDeclaration/settlementPaymenAccountDebtTaxpayerBehalf/SettlementTaxpayerDebt.module.css";
import stylesRequestData from "../UnifiedTaxDeclarationRequestData/index.module.css";
import InputElement from "../../../shared/form/InputElement";
import { validateRequired } from "../../../helpers/Validation";
import { previewAndDownloadDeclerationFile } from "../../../adapters/apis/lookups/lookups";
import { post } from "../../../adapters/xhr/api";

import DownloadFile from "../../../helpers/DownloadFile";
import infoIconSvg from "../../../assets/img/Icon-metro-info.svg";
import InfoPopover from "../../../shared/form/InfoPopover";

const DebtSupportingDocuments = ({
  setShowFiles,
  unitId,
  setUnits,
  documents,
  declarationStatus,
  declarationId,
}) => {
  const documentFileInputRef = useRef({});

  const [supporting_documents, setSupportingDocuments] = useState(
    documents || [],
  );
  const [fileErrors, setFileErrors] = useState([]);
  const [inputKeys, setInputKeys] = useState({});
  const [uploadFileError, setUploadFileError] = useState(null);
  const [
    isButtonDisabledIfAttachmentFilesAreNotValid,
    setIsButtonDisabledIfAttachmentFilesAreNotValid,
  ] = useState(false);

  const handlePreviewFile = async (url) => {
    try {
      const response = await previewAndDownloadDeclerationFile(url);

      const blob = new Blob([response?.data], {
        type: response.headers["content-type"],
      });

      // Create a URL for the blob
      const fileUrl = URL.createObjectURL(blob);
      window.open(fileUrl, "_blank");
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const handleDownloadFile = async (url) => {
    try {
      const response = await previewAndDownloadDeclerationFile(url);

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      // Extract filename from Content-Disposition header
      let fileName = "file"; // Default filename
      let originFileName = "file";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(/filename="(.+?)"/);
        if (match) {
          originFileName = match[1];
        }
      }

      const mimeType = blob.type;
      const ext = originFileName.split(".").pop().toLowerCase();

      if (ext === "jfif" || mimeType === "image/jfif") {
        fileName = "file.jfif";
      } else if (mimeType === "image/jpeg" || mimeType === "image/jpg") {
        fileName = ext === "jpg" ? "file.jpg" : "file.jpeg";
      }

      // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName.replace(/"/g, ""); // Remove any quotes
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const addAttachment = () => {
    const newDoc = {
      id: Math.random(),
      name: null,
      file: null,
      original_file_name: null,
      path: null,
      full_url: null,
    };

    setSupportingDocuments((prev) => [...prev, newDoc]);
    setFileErrors((prev) => ({
      ...prev,
      [newDoc.id]: {
        name: "",
        file: "",
        original_file_name: "",
        path: "",
        full_url: "",
      },
    }));
  };

  const removeAttachmentById = (id) => {
    setIsButtonDisabledIfAttachmentFilesAreNotValid(false);
    setSupportingDocuments((prev) => prev.filter((doc) => doc.id !== id));

    setFileErrors((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const updateDocumentName = (id, newName) => {
    // setAttachments((prev) =>
    //   prev.map((item) => (item.id === id ? { ...item, name: newName } : item))
    // );
    setSupportingDocuments((prev) =>
      prev.map((doc) => (doc.id === id ? { ...doc, name: newName } : doc)),
    );
  };

  const updateDocumentFile = async (id, file) => {
    try {
      setIsButtonDisabledIfAttachmentFilesAreNotValid(true);
      const data = new FormData();
      data.append(`label`, "debt_supporting_documents");
      data.append(`file`, file);
      if (file) {
        const response = await post(
          "api/declaration-system/declarations/upload-attachments",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );
        setIsButtonDisabledIfAttachmentFilesAreNotValid(false);
        setSupportingDocuments((prev) =>
          prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  file: response?.data?.data?.file,
                  original_file_name: response?.data?.data?.original_file_name,
                  path: response?.data?.data?.path,
                  full_url: response?.data?.data?.full_url,
                }
              : item,
          ),
        );
        setUploadFileError(null);
      }
    } catch (error) {
      setIsButtonDisabledIfAttachmentFilesAreNotValid(true);
      if (error.status === 422) {
        setSupportingDocuments((prev) =>
          prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  file: null,
                  original_file_name: null,
                  path: null,
                  full_url: null,
                }
              : item,
          ),
        );
        window.scrollTo(0, 0);
        // setError(key, "يجب رفع الصورة");
        setUploadFileError(error?.response?.data?.errors?.file);
      }
    }
  };

  const setFileErrorById = (id, field, message) => {
    setFileErrors((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: message,
      },
    }));
  };

  const handleRemoveFileForAdditionalAttachment = (id) => {
    setInputKeys((prev) => ({
      ...prev,
      [id]: (prev[document.id] || 0) + 0.1,
    }));
    setSupportingDocuments((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              file: null,
              full_url: null,
              original_file_name: null,
              path: null,
            }
          : item,
      ),
    );
    const inputElement = documentFileInputRef?.current[document.id];

    if (inputElement instanceof HTMLInputElement) {
      inputElement.value = null;
    }
  };

  const validateAttachments = () => {
    const errors = {};

    supporting_documents?.forEach((doc) => {
      errors[doc.id] = {
        name:
          doc.name === null || doc.name === "" ? "يجب إدخال اسم المستند" : "",
        file: doc.file === null ? "يجب رفع الصورة" : "",
      };
    });

    setFileErrors(errors);
  };

  useEffect(() => {
    validateAttachments();
  }, [supporting_documents]);

  useEffect(() => {
    (supporting_documents || [])?.forEach((document) => {
      if (!documentFileInputRef.current[document.id]) {
        documentFileInputRef.current[document.id] = createRef();
      }
    });
  }, [supporting_documents]);

  useEffect(() => {
    let currentDocuments = supporting_documents || [];

    if (currentDocuments?.length === 0) {
      const singleAttachment = {
        id: Math.random(),
        name: null,
        file: null,
        original_file_name: null,
        path: null,
        full_url: null,
      };
      setSupportingDocuments((prev) => [...prev, singleAttachment]);
      setFileErrors((prev) => ({ ...prev, [singleAttachment.id]: "" }));
    }
  }, []);

  const handleAddDocumentsToClaim = async () => {
    setUnits((prev) => {
      const updatedUnits = prev.map((unit) =>
        unit.id === unitId ? { ...unit, supporting_documents } : unit,
      );

      // Find the updated unit so we can use its data
      const updatedUnit = updatedUnits.find((u) => u.id === unitId);

      if (updatedUnit) {
        (async () => {
          try {
            const url = `api/declaration-system/declarations/upload-debt-supporting-document`;

            const data = {
              declaration_id: updatedUnit.declaration_id || declarationId,
              property_type_id: updatedUnit.property_type_id,
              id: updatedUnit.id,
              debt_supporting_documents: updatedUnit.supporting_documents,
            };

            await post(
              url,
              {
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
              },
              data,
            );
            setShowFiles(false);
          } catch (error) {
            console.error("Error uploading documents:", error);
          }
        })();
      }

      return updatedUnits;
    });
  };

  const isUploadButtonDisabled = () => {
    return (
      Object.values(fileErrors).some(
        (error) => error.name !== "" || error.file !== "",
      ) ||
      supporting_documents?.length > 5 ||
      isButtonDisabledIfAttachmentFilesAreNotValid
    );
  };

  return (
    <div className="container pt-4">
      {uploadFileError && (
        <div
          className="alert alert-danger  mt-3"
          id="backend_error"
          role="alert"
        >
          {uploadFileError.map((i) => (
            <li className="" key={i}>
              {i}
            </li>
          ))}
          {}
        </div>
      )}
      <div className={styleData.box}>
        <div className={`${styleData["box-header"]}`}>
          <div className="d-flex align-items-center flex-wrap">
            <button
              className={`${styleData["btn-arrow"]} ms-3`}
              onClick={() => setShowFiles(false)}
            >
              <i className="fa-solid fa-arrow-right mt-1"></i>
            </button>

            <h3 className="mb-0 ms-2 fw-bold">مستندات دالة على المديونية</h3>
          </div>
        </div>
        <div className="mt-5">
          {" "}
          {supporting_documents?.length > 0 && (
            <>
              {supporting_documents?.map((document, index) => {
                return (
                  <div className="row " key={document.id}>
                    <div className="col-12 col-md-4 ">
                      <InputElement
                        value={document.name || ""}
                        name="name"
                        onChange={(e) => {
                          updateDocumentName(document.id, e?.target?.value);
                        }}
                        mb4="mb-4"
                        labelHtmlFor="name"
                        labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                        labelText="اسم المستند"
                        inputType="text"
                        inputClassName={`${stylesRequestData["form-control"]} form-control`}
                        inputID="document_name_input"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={fileErrors[document.id]?.name || ""}
                        allowedPattern={
                          /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
                        }
                        maxLength={100}
                        customChange={true}
                      />
                    </div>
                    <div className="col-12 col-md-4 ">
                      <InputElement
                        key={inputKeys[document.id] || 0}
                        fileInputRef={documentFileInputRef.current[document.id]}
                        labelHtmlFor="file"
                        labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                        labelText="اختيار ملف"
                        name="file"
                        inputType="file"
                        fileName={
                          supporting_documents?.find(
                            (item) => item.id === document.id,
                          )?.original_file_name || "إرفاق ملف"
                        }
                        inputID={`document_file_input_${document.id}`}
                        inputClassName={`${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                        inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                        icon="fa-solid fa-cloud-arrow-up"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={fileErrors[document.id]?.file || ""}
                        onChange={async (parent, component, name, file) => {
                          if (file) {
                            if (!validateRequired(file)) {
                              setFileErrorById(
                                document.id,
                                "name",
                                "يجب رفع الصورة",
                              );
                              return;
                            }

                            setFileErrorById(document.id, "name", "");
                            setFileErrorById(document.id, "file", "");

                            updateDocumentFile(document.id, file);
                          }
                        }}
                        accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                        disabled={
                          !validateRequired(document.name)
                          //    ||
                          //   declarationRequest?.viewMode ||
                          //   declarationRequest?.isUnitViewMode
                        }
                        // deleteFunction={() =>
                        //   handleRemoveFileForAdditionalAttachment(document?.id)
                        // }
                      />
                    </div>

                    <div className="col-md-4 col-sm-6 row gap-2">
                      <div className="col-md-5 col-sm-6 ">
                        {[2, 3].includes(declarationStatus) && (
                          <button
                            onClick={() => removeAttachmentById(document.id)}
                            className={` ${stylesRequestData["btn-delete"]} text-danger`}
                            style={{ marginTop: "33px" }}
                          >
                            حذف المستند{" "}
                            <i className="fa-regular fa-trash-can fa-lg ml-1"></i>
                          </button>
                        )}
                      </div>
                      {index === supporting_documents.length - 1 && (
                        <div className="col-md-5 col-sm-6 ">
                          <button
                            onClick={() => addAttachment()}
                            className={` ${
                              !validateRequired(document.name) ||
                              !validateRequired(document.path) ||
                              supporting_documents.length === 5
                                ? stylesRequestData["btn-add-disabled"]
                                : stylesRequestData["btn-add"]
                            } `}
                            style={{ marginTop: "33px" }}
                          >
                            إضافة مستند آخر
                          </button>
                        </div>
                      )}
                    </div>
                    {document?.full_url && (
                      <div className="col-md-4 col-sm-6">
                        <label
                          htmlFor="document_file_value"
                          labelHtmlFor="document_file_value"
                          className={`${stylesRequestData["form-label"]} form-label`}
                        >
                          صورة المرفق
                        </label>
                        <div
                          className=" col-2-4 d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-2 px-2 align-items-center mb-3"
                          name="document_file_value"
                        >
                          <p
                            className="mb-0 file-name fs-6"
                            title={document?.original_file_name}
                          >
                            {document?.original_file_name}
                          </p>
                          <div className="d-flex align-items-center py-2">
                            <span
                              type="button"
                              onClick={() =>
                                handlePreviewFile(document?.full_url)
                              }
                              className={`text-danger border-0`}
                            >
                              <i
                                className="fa-slab-press fa-regular fa-eye fa-lg px-2"
                                style={{ color: "#32A8ED" }}
                              ></i>
                            </span>
                            <span
                              type="button"
                              onClick={() =>
                                handleDownloadFile(document?.full_url)
                              }
                              className={`text-danger border-0`}
                            >
                              <i
                                className="fa-solid fa-cloud-arrow-down fa-lg px-2"
                                style={{ color: "#32A8ED" }}
                              ></i>
                            </span>
                            {[2, 3].includes(declarationStatus) && (
                              <span
                                type="button"
                                onClick={() =>
                                  handleRemoveFileForAdditionalAttachment(
                                    document?.id,
                                  )
                                }
                                className={`text-danger border-0`}
                              >
                                <i className="fa-solid fa-trash fa-lg px-2"></i>
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </>
          )}
          <div>
            {supporting_documents?.length === 0 && (
              <>
                <div className="col-md-5 col-sm-6 ">
                  <button
                    onClick={() => addAttachment()}
                    className={` ${stylesRequestData["btn-request"]} `}
                    style={{ marginTop: "33px", marginBottom: "15px" }}
                  >
                    إضافة مستند
                  </button>
                </div>
              </>
            )}
            <div className="d-flex align-items-center">
              <button
                className={` ${
                  isUploadButtonDisabled()
                    ? stylesRequestData["btn-request-disabled"]
                    : stylesRequestData["btn-request"]
                } `}
                onClick={handleAddDocumentsToClaim}
              >
                حفظ{" "}
              </button>
              <div className="col-lg-4 col-sm-6">
                <InfoPopover content=" الحد الأقصى هو رفع خمس ملفات للمستندات الدالة على المديونية">
                  <img
                    src={infoIconSvg}
                    alt="info"
                    width="24"
                    height="24"
                    style={{ display: "block", marginRight: "20px" }}
                  />
                </InfoPopover>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebtSupportingDocuments;
